<template>
  <div>
    <div class="van-clearfix inputTop">
      <div class="flexOne s_input flexCenter">
        <div class="searchPart flexCenter">
          <div class="a_name" @click="addressShow = true">{{cityName}}</div>
          <img src="@/assets/img/arrow-back.png" alt="" class="arrow-back" @click="addressShow = true">
<!--          <img src="@/assets/img/healthy_icon_search.png" alt="" class="search_icon" @click="searchInput">-->
        </div>

<!--        <input type="text" class="searchInput flexOne" placeholder="请输入关键词" readonly  @click="goSearch">-->
<!--          <img src="@/assets/img/healthy_icon_search.png" alt="" class="search_icon_bg">-->
        <div class="flexOne flexCenter">
          <van-field v-model="searchWord"  class="searchInput flexOne" placeholder="请输入关键词" @keyup.enter="searchInput"/>
          <img src="@/assets/img/healthy_icon_search.png" alt="" class="search_icon_bg" @click="searchInput">
        </div>

      </div>
    </div>
    <div class="commonPadding">
      <!-- 代码重要 勿删-->
<!--      <div v-if="tempGoodList.length > 0" class="van-clearfix">-->
<!--        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">-->
<!--          <van-list v-model="isUpLoading" :finished="upFinished" :immediate-check="false"-->
<!--                    :offset="offset" finished-text="我是有底线的" @load="onLoadList">-->
<!--            <ul class="newsUl van-clearfix" v-if="tempGoodList.length > 0">-->
<!--              <li class="actLi" v-for="(item,index) in tempGoodList" :key="index" @click="goodDetail(item)">-->
<!--                <div class="van-clearfix">-->
<!--                  <img :src="baseImg + item.imgUrl" alt="" class="imgPic">-->
<!--                  <div class="proName">{{item.wikiName}}</div>-->
<!--                  <div class="desc">{{item.desc}}</div>-->
<!--                  <div class="desc">价格：{{item.visitCount}}</div>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </van-list>-->
<!--        </van-pull-refresh>-->
<!--      </div>-->
      <div v-if="tempGoodList.length > 0" class="van-clearfix">
        <van-pull-refresh v-model="isDownLoading"
                          @refresh="onDownRefresh">
          <van-list v-model="isUpLoading"
                    :finished="upFinished"
                    :immediate-check="false"
                    :offset="offset"
                    finished-text=""
                    @load="onLoadList">
            <ul class="newsUl van-clearfix" v-if="tempGoodList.length > 0">
              <li class="actLi" v-for="(item,index) in tempGoodList" :key="index" @click="clubDetail(item)">
                <div class="van-clearfix actBox">
    <!--              <img :src="baseImg + item.imgUrl" alt="" class="imgPic">-->
<!--                  <img v-if="item.clubThumbnail" :src="baseImg + item.clubThumbnail" alt="" class="imgPic">-->
                  <img :src="baseImg + item.clubThumbnail" alt="" class="imgPic" @load="activityLoad (item.clubThumbnail, index)" v-show="item.clubThumbnail && loadingImges[index]">
                  <img src="@/assets/img/iv_placeholder_Center@2x.png" v-show="!item.clubThumbnail || !loadingImges[index]"  class="imgPic">
    <!--              <img :src="baseImg + item.clubThumbnail" alt="" class="imgPic">-->
                  <div class="proName">{{item.clubName}}</div>
    <!--              <div class="serviceList">-->
    <!--                <ul class="van-clearfix"  v-if="item.serviceList.length > 0">-->
    <!--                  <li class="inBlock" v-for="(itemWrap,indexWrap) in item.serviceList" :key="indexWrap">-->
    <!--                    <div class="serviceLi" v-if="indexWrap < 3">-->
    <!--                      {{itemWrap}}-->
    <!--                    </div>-->
    <!--                  </li>-->
    <!--                </ul>-->
    <!--              </div>-->
                  <div v-if="item.clubProductCategorys" class="serviceList">
                    <div  v-if="item.clubProductCategorys">
                      <ul class="van-clearfix"  v-if="item.clubProductCategorys.length > 0">
                        <li class="inBlock" v-for="(itemWrap,indexWrap) in item.clubProductCategorys" :key="indexWrap">
                          <div class="serviceLi" v-if="indexWrap < 3">
                            {{itemWrap}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
    <!--              <div class="desc" v-if="item.clubProductCategorys">-->
    <!--                <ul class="van-clearfix"  v-if="item.clubProductCategorys.length > 0">-->
    <!--                  <li class="inBlock" v-for="(itemWrap,indexWrap) in item.clubProductCategorys" :key="indexWrap">-->
    <!--                    <div class="otherServiceLi" v-if="indexWrap < 3">-->
    <!--                      {{itemWrap}}-->
    <!--                    </div>-->
    <!--                  </li>-->
    <!--                </ul>-->
    <!--              </div>-->
                  <div class="desc" v-if="item.serviceList">
                    <ul class="van-clearfix"  v-if="item.serviceList.length > 0">
                      <li class="inBlock" v-for="(itemWrap,indexWrap) in item.serviceList" :key="indexWrap">
                        <div class="otherServiceLi" v-if="indexWrap < 3">
                          {{itemWrap}}
                        </div>
                      </li>
                    </ul>
                  </div>

                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else style="padding-top: 5rem;">
        <img src="@/assets/img/iv_error1@2x.png"
             class="noAct" />
        <div class="actText">暂无门店</div>
      </div>
    </div>
    <div class="mask" @click="c_cancel" v-if="addressShow"></div>
    <van-area title="选择地区" :area-list="areaList" v-if="addressShow" :value="defaultCode" :columns-num="2" @cancel="c_cancel" @confirm="c_confirm" />
<!--    <div id="test">test</div>-->
<!--    <div  v-for="(item,index) in cityArray" :key='index' style="font-size: 12px">-->
<!--     {{item[0]}}: '{{item[1]}}',-->
<!--    </div>-->
  </div>

</template>
<script>
import { removeParams, removeUser, getToken, setToken, setUid, setIsSystem, removeToken, getCode, getUid, removeCode, removeUid } from 'utils/auth'
import { parseTime, getUrlParam, isWeixin } from 'utils/index'
import { CODE_OK } from 'utils/publicData'
import { loadBMap } from "utils/BMap";
// import areaList from "utils/Area";
// import areaList from "utils/City";
import areaList from "utils/CityTest";
import codeList from "utils/bCityCodeCompare";
import EnvionmentVariables from '../../../../baseUrl'
export default {
  name: 'todayActivity',
  components: {
  },
  data () {
    return {
      active: 0,
      baseImg: EnvionmentVariables.IMAGE_HOST,
      tabAct: false,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 8, // 每页请求的数量
      total: 0, // 总共的数据条数
      tempGoodList: [],
      areaList: areaList,
      addressShow: false,
      address: "",
      searchWord: '',
      cityName: '获取',
      // areaCode: '440305',
      areaCode: '',
      defaultCode: '440300',
      loadingImges: {},
      longitude: '',
      latitude: '',
      array: [],
      codeList: codeList
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#fff;');
  },
  created () {
    var token = this.$route.query.appToken;
    // var areaCode = this.$route.query.areaCode;
    // this.defaultCode =  this.$route.query.areaCode + '000000';
    // var cityName =  this.$route.query.cityName;
    // var district =  this.$route.query.district;
    // this.longitude = this.$route.query.longitude;
    // this.latitude = this.$route.query.latitude;
    // console.log("this.$route.query")
    // console.log(this.$route.query)
    // console.log("longitude")
    // console.log(this.longitude)
    // console.log("latitude")
    // console.log(this.latitude)
    console.log("token");
    console.log(token);
    if (token) {
      setToken(token);
    }
    // if (areaCode) {
    //   this.areaCode = areaCode
    // }
    // if (cityName) {
    //   this.cityName = cityName
    // }
    // if (areaCode) {
    //   this.getClubPageByCondtion();
    // } else {
    //   this.init()
    // }
    this.init()
    // // 发版本时 注掉下面的代码
    // if (areaCode) {
    //   this.getClubPageByCondtion();
    // }
  },
  mounted () {
    // this.getRegionTree()
  },
  methods: {
    //
    getRegionTree () {
      var that = this;
      var param = {
        service: "basic",
        query: "-1"
      }
      this.$api.getRegionTree(param).then(res => {
        if (res) {
          for (var i = 0; i < res.data.result.length; i++) {
            that.getAgen(res.data.result[i].code)
          }
        }
      }).catch(err => {
      })
    },
    getAgen (cityCode) {
      var that = this;
      var param = {
        service: "basic",
        query: cityCode.toString()
      }
      this.$api.getRegionTree(param).then(res => {
        if (res) {
          that.array = that.array.concat(res.data.result);
        }
      }).catch(err => {
      })
    },
    activityLoad (imgId, imgIndex) {
      console.log(111)
      if (imgId) {
        this.loadingImges[imgIndex] = true;
        this.$forceUpdate();
      }
    },
    init () {
      const _this = this;
      loadBMap('MmKNtMcwp0gV4Y0117ZS17PPBIHUT1bX').then(BMap => {
        console.log("进来BMap")
        // loadBMap('sxpQFd2GkOjQ2Cqg7hs9E7t8HrS6O7E4').then(BMap => {
        const geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
          console.log("r")
          console.log(r)
          _this.cityName = r.address.city;
          $.ajax({
            url: 'https://api.map.baidu.com/geocoder/v2/?ak=MmKNtMcwp0gV4Y0117ZS17PPBIHUT1bX&location=' + r.point.lat + ',' + r.point.lng + '&output=json',
            dataType: 'jsonp',
            callback: 'BMap._rd._cbk43398',
            success: function (res) {
              console.log("output");
              console.log(res);
              var result = res.result;
              var cityCode = result.cityCode; // 注意是市级code
              _this.getStstemCode(cityCode)
            },
            error: function () {

            }
          });
        })
      })
    },
    //
    getStstemCode (cityCode) {
      for (var i in this.codeList.list) {
        if (i == cityCode) {
          this.areaCode = this.codeList.list[i];
          this.defaultCode = this.areaCode;
          this.getClubPageByCondtion();
        }
      }
    },
    c_cancel () {
      this.addressShow = false
    },
    c_confirm (array) {
      this.address = array[0].name + array[1].name;
      this.cityName = array[1].name;
      this.areaCode = array[1].code;
      this.defaultCode = array[1].code;
      this.addressShow = false;
      this.pageIndex = 1;
      this.tempGoodList = [];
      this.getClubPageByCondtion();
    },
    encyclopediaList () {
      this.$router.push({ path: '/encyclopediaList', query: {} });
    },
    order () {
      this.$router.push({ path: '/order', query: {} });
    },
    shopCart () {
      this.$router.push({ path: '/shopCart', query: {} });
    },
    clubDetail (item) {
      this.$router.push({ path: '/clubDetail', query: { id: item.id, title: item.clubName } });
    },
    goSearch () {
      this.$router.push({ path: '/search', query: {} });
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector('#tab').offsetTop;
      if (scrollTop >= offsetTop) {
        document.querySelector('#appNav').style.position = 'fixed';
        document.querySelector('#appNav').style.top = '0px';
      } else {
        document.querySelector('#appNav').style.position = 'absolute';
      }
    },
    scroll () {
      this.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
    },
    searchInput () {
      this.tempGoodList = []
      this.getClubPageByCondtion()
    },
    // 获取会所列表
    getClubPageByCondtion () {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          clubName: this.searchWord,
          areaCode: this.areaCode
        },
        pageIndex: that.pageIndex,
        pageSize: that.pageSize
      }
      this.$api.getClubPageByCondtion(param).then(res => {
        if (res) {
          that.total = res.data.rows;
          // 数据全部加载完成
          if (that.tempGoodList.length >= that.total) {
            that.upFinished = true; // 加载结束
          } else {
            that.tempGoodList = that.tempGoodList.concat(res.data.result);
            that.tempGoodList.forEach(function (item) {
              item.serviceList = item.serviceFeatures.split(",")
            })
          }
          if (res.data.result.length < that.pageSize) {
            that.upFinished = true;
          }
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        console.log('finally')
        this.isDownLoading = false;
        this.isUpLoading = false;
      });
    },
    // 下拉刷新.
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.tempGoodList = [];
        this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getClubPageByCondtion(); // 加载数据
        this.timer = null // 清空定时器
      }, 300)
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getClubPageByCondtion();
    }
  }
}
</script>

<style scoped lang="less">
  /deep/  .van-field__control{
    padding-right: 32px;
  }
  /deep/ .van-cell{
    padding: 0;
    padding-left: 0;
  }
  /deep/ .van-picker{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    z-index: 10000;
  }
  .inBlock{
    display: inline-block;
    margin-bottom: 4px;
  }
  .otherServiceLi{
    padding: 8px;
    background: rgba(53, 125, 250, 0.1);
    border-radius: 4px;
    color: #357DFA;
    font-size: 20px;
    display: inline-block;
    margin-left: 18px;
  }
  inBlock:last-child .serviceLi{
    border: none
  }
  .serviceLi{
    height: 28px;
    padding: 0 18px;
    border-right:2px solid rgba(208, 214, 230, 0.3);
    display: inline-block;
  }
  .serviceList{
    color: #3E3E3E;
    font-size: 20px;
    margin-bottom: 20px;
    margin-top: 10px;
    height: 30px;
    overflow: hidden;
    line-height: 1.3;
  }
  .a_name{
    font-size: 32px;
    color: #3E3E3E;
  }
  .search_icon{
    /*width: 96px;*/
    /*height: 96px;*/
    width: 64px;
    height: 64px;;
  }
  .search_icon_bg{
    position: absolute;
    width: 96px;
    height: 96px;
    right: 0;
  }
  .arrow-back{
    width: 60px;
    height: 60px;
  }
  .searchPart{
    min-width: 150px;
    max-width:280px;
    height: 64px;
    padding-left: 20px;
  }
  .newsUl{
    padding: 128px 24px 24px 24px;
  }
  .desc{
    font-size:26px;
    color: #999;
    height: 60px;
    margin-bottom: 0.4rem;
  }
  .proName{
    font-size: 30px;
    padding: 12px 18px;
    color: #3E3E3E;
    font-weight: bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .imgPic{
    width: 336px;
    height: 236px;
    display: block;
    margin: 0px auto;
    border-radius: 12px 12px 0 0;
  }
  .actLi{
    width: 50%;
    float: left;
    padding: 0px 8px;
    box-sizing: border-box;
    border-radius: 12px;
    margin-bottom: 16px;
  }
  .actBox{
    min-height: 408px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    border-radius: 12px;
  }
  .s_input{
    position: relative;
    display: flex;
    border-radius: 12px;
    background: #fff;
  }
  /*.searchInput{*/
  /*  font-size: 32px;*/
  /*  color: #3E3E3E;*/
  /*  width: 100%;*/
  /*  height: 64px;*/
  /*  border-radius: 12px;*/
  /*}*/
  .searchInput{
    /*border: 1px solid #d1d1d1;*/
    border-radius: 12px;
    /*background: rgba(208, 214, 230, 0.21);*/
    padding-top: 0;
    font-size: 32px;
    padding-bottom: 0;
    height: 64px;
    line-height: 64px;
    padding-left: 0;
    padding-right: 96px;
    box-sizing: border-box;
  }
  .inputTop{
    height: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    background: #357DFA;
    width: 100%;
    padding: 0 32px;
    box-sizing: border-box;
    z-index: 1000;
  }
  .flexOne{
    flex:1;
  }
  .carIcon{
    width: 1rem;
    height: 1rem;
    margin: auto;
    display: block;
  }
  .car{
    width: 1.5rem;
  }
  .noAct {
    width: 356px;
    height: 282px;
    display: block;
    margin: 0 auto 42px;
  }
  .actText{
    font-size: 0.3rem;
    text-align: center;
    color: #999;
  }
  .topNav{
    width: 100%;
    //position: fixed;
    box-sizing: border-box;
    height: 88px;
    line-height: 88px;
    top:0;
    z-index: 1000;
  }
  #tab{
    position: relative;
    height: 88px;
  }
  #appNav{
    width: 100%;
    height: 88px;
    overflow:hidden;
    position: absolute;
    left: 0;
    top: 0;
    background: #FFF1F0;
  }
  #appNav nav{
    padding: 0 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: middle;
    -ms-flex-align: middle;
    align-items: middle;
    overflow: auto;
  }
  #appNav p{
    text-align: center;
    font-size: 28px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    padding: 0px 50px;
    height: 100%;
    position: relative;
  }
  #appNav p.active{
    color: #E52317;
  }
  #appNav p.active::after{
    content: "";
    display: block;
    position: absolute;
    width: 45px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 4px;
    background: #E52317;
    border-radius: 2px;
  }
  #appNav p.active[data-v-1258668a] {
    color: #E52317;
  }
  input::-webkit-input-placeholder{
    line-height: 50px;
  }
</style>
